export default {
  contratosSincronizando: {}
};